import ReactDirective from "acl-ui/angular/reactDirective.umd";
import KeyBoardShortcut from "@viz-ui/components/keyboardShortcutButton";

angular
  .module("acl.storyboard.presenter.keyshortcut", [])
  .directive("keyboardShortcut", ReactDirective.getFactory(KeyBoardShortcut));
